import React from 'react';
import cx from 'classnames';
import './HeroBannerSection.scss';
import Button from '../../../components/Button/Button';

export default function HeroBannerSection({getPrequalified, countryCode}) {
  return (
    <>
      <div
        className={cx({
          'prequal--web-ford-motion-hero-banner-section-usa': countryCode === 'USA',
          'prequal--web-ford-motion-hero-banner-section-canada': countryCode === 'CAN'
        })}
      >
        <div className='prequal--web--hero-banner-section-compact-text'>
          <span>Your Next Ford</span>
          <span>Is One Click Away</span>
        </div>
        <div className='prequal--web--hero-banner-section-compact-subtext'>
          <span>Get prequalified today. </span>
          <span>Zero credit impact, no obligation.</span>
        </div>
        <Button
          dataTestId='get-prequalified-button'
          label='Get Prequalified'
          onClick={() => getPrequalified(false)}
          buttonStyle='primary'
        />
      </div>
    </>
  );
}
